import React from "react"
import { NavLink } from "react-router-dom"
import Header4 from "../Common/Header4"
import Footer from "../Common/Footer"
import Banner from "../Elements/Banner"
import Projects6 from "../Elements/Projects6"
import ReactPlayer from "react-player"

var bnrimg = require("./../../images/projects/portrait/Marassi/bg.png")

class Marassi extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script")
        script.src = src
        script.addEventListener("load", function () {
          resolve()
        })
        script.addEventListener("error", function (e) {
          reject(e)
        })
        document.body.appendChild(script)
        document.body.removeChild(script)
      })
    }

    loadScript("./assets/js/custom.js")
  }
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Banner
            title="Villa · Marassi · North Coast"
            pagename="Marassi North Coast Villa"
            description="Transforming this Marassi North Coast villa into a minimalist luxury retreat—where clean architecture, pure lines, and thoughtfully curated materials come together to create a serene, elevated living experience shaped by simplicity, balance, and understated elegance."
            bgimage={bnrimg}
          />

          {/* SECTION CONTENT START */}
          <div className="section-full p-tb80 inner-page-padding stick_in_parent">
            <div className="container">
              <div className="row">
                <div className="col-lg-7 col-md-7  sticky_column">
                  <div className="project-detail-containt">
                    <div className="bg-white text-black">
                      <h3>
                        A minimalist luxury design vision shaped by clarity and
                        calm
                      </h3>

                      <p>
                        In this Marassi North Coast villa, design is defined by
                        purity of form, balanced proportions, and refined
                        restraint. Clean architectural lines are paired with a
                        soft, natural material palette, creating interiors that
                        feel serene, warm, and effortlessly elegant. Every
                        element is intentionally considered to enhance comfort,
                        visual clarity, and a sense of quiet luxury— where
                        simplicity becomes the ultimate expression of
                        sophistication.
                      </p>

                      <p>
                        The villa unfolds through thoughtfully composed spaces,
                        offering generous bedrooms including a tranquil master
                        suite, an open kitchen designed for relaxed coastal
                        living and entertaining, refined bathrooms, and calm
                        reception areas connected through seamless circulation.
                        Each space is crafted to balance openness and privacy,
                        resulting in a home that reflects refined living,
                        individuality, and minimalist luxury by the sea.
                      </p>

                      <div className="product-block">
                        <ul>
                          <li>
                            <h4 className="m-b10">Status</h4>
                            <p>Completed</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Client</h4>
                            <p>Property Owner</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Project type</h4>
                            <p>Villa Marassi</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Scope of work</h4>
                            <p>Design and build</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Location</h4>
                            <p>Marassi, North Coast</p>
                          </li>
                          <li>
                            <h4 className="m-b10">Year</h4>
                            <p>2024</p>
                          </li>
                        </ul>
                      </div>
                      <div className="m-b0">
                        <div className="sx-divider divider-1px  bg-black">
                          <i className="icon-dot c-square" />
                        </div>
                      </div>
                      {/* <ul className="social-icons social-square social-darkest m-b0">
                                            <li><a href="https://www.facebook.com" target="_blank" className="fa fa-facebook" /></li>
                                                <li><a href="https://twitter.com" target="_blank" className="fa fa-twitter" /></li>
                                                <li><a href="https://in.linkedin.com" target="_blank" className="fa fa-linkedin" /></li>
                                                <li><a href="https://rss.com" target="_blank" className="fa fa-rss" /></li>
                                                <li><a href="https://www.youtube.com" target="_blank" className="fa fa-youtube" /></li>
                                                <li><a href="https://www.instagram.com/innen_interiors/" target="_blank" className="fa fa-instagram" /></li>
                                            </ul> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-md-5 ">
                  <div className="project-detail-outer">
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/1.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/2.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/3.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/4.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/5.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/6.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/7.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/8.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/9.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/10.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/11.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/12.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/13.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/14.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    <div className="project-detail-pic m-b30">
                      <div className="sx-media">
                        <img
                          src={require("./../../images/projects/portrait/Marassi/15.jpg")}
                          alt=""
                        />
                      </div>
                    </div>
                    {/* <div className="sx-box">
                                            <div className="sx-thum-bx sx-img-overlay1 sx-img-effect yt-thum-box">
                                                <img src="https://img.youtube.com/vi/Oy2QIiSQT2U/0.jpg" alt="" />
                                                <NavLink to={"#"} className="play-now" data-toggle="modal" data-target="#myModal5">
                                                    <i className="icon fa fa-play" />
                                                    <span className="ripple" />
                                                </NavLink>
                                            </div>
                                        </div> */}
                  </div>
                </div>
              </div>
              <div className="project-detail-containt-2 m-t50">
                <h3>
                  Creating a minimalist luxury home shaped by balance,
                  simplicity, and contemporary comfort
                </h3>

                <p className="m-b0">
                  Minimalist luxury is guided by clarity rather than excess.
                  Pure lines, balanced proportions, and thoughtfully selected
                  materials create a serene atmosphere of understated
                  elegance—where comfort feels effortless and space breathes
                  naturally. Through careful planning and refined restraint, the
                  villa becomes a calm coastal retreat that elevates everyday
                  living with precision, softness, and timeless appeal.
                </p>
              </div>
            </div>
          </div>
          {/* SECTION CONTENT END  */}
          {/* <Projects6 /> */}
        </div>

        <div className="modal fade" id="myModal5" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <ReactPlayer url="https://www.youtube.com/watch?v=Oy2QIiSQT2U" />
            </div>
          </div>
        </div>
        <Footer />
      </>
    )
  }
}

export default Marassi
